import React, { useState, useRef, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import SimpleReactValidator from 'simple-react-validator';
import Modal from 'react-bootstrap/Modal';
import { web, user } from '../../helpers/api';
import { ENDPOINT, PATH, entitiesLabels, message } from '../../helpers/Constants';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
function RegistrazioneMedicoWeb() {
    const validator = useRef(new SimpleReactValidator())
    const validatorOTP = useRef(new SimpleReactValidator())
    const validationPhone = useRef(new SimpleReactValidator())
    const [formData, setFormData] = useState({
        IdMedico: 0,
        nome: '',
        cognome: '',
        email: '',
        codiceMedico: '',
        numeroTelefono: '',
        idCentroMedico: null,
        centroMedico: '',
        password: '',
        confirmpassword: '',
        otp: ''
    });
    const [formDatack, setFormDatack] = useState({
        ck1: null,
        ck1: null,
        ck1: null
    });
    const [phone, setPhone] = useState('');
    const [isSuccessSendOtp, setIsSuccessSendOtp] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(false);
    const [centrimedici, setCentrimedici] = useState([]);
    const [ismodalpdf, setIsmodalpdf] = useState(false);
    const [ck, setCK] = useState('');
    const [pdfElement, setPdfElement] = useState('');
    useEffect(() => {
        const fetchCentriMedici = async () => {
            await web.getAll(ENDPOINT.ELENCOCENTRIMEDICIATTIVI)
                .then((response) => {
                    if (response.status === 200) {
                        setCentrimedici(response.data.dati);
                    }
                }).catch((error) => {

                });
        }
        fetchCentriMedici();
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleInputChangeck = (e) => {
        if (e != null) {
            setCK(e.target.name)
            if (e.target.name === 'ck1') {
                setPdfElement('/pdf/InformativaMedicoPuntoA.pdf')
            }
            if (e.target.name === 'ck2') {
                setPdfElement('/pdf/InformativaMedicoPuntoB.pdf')
            }
            if (e.target.name === 'ck3') {
                setPdfElement('/pdf/InformativaMedicoPuntoC.pdf')
            }
        }
        setIsmodalpdf(!ismodalpdf)
    };
    const confirmInputChangeck = (numerocheck) => {
        const { name } = numerocheck;
        setFormDatack({ ...formDatack, [numerocheck]: true });
        setIsmodalpdf(!ismodalpdf)
    };
    const handleInputChangeCentro = (e) => {
        const { name, value } = e.target;
        const propertyName = 'idCentroMedico';
        setFormData({ ...formData, [name]: parseInt(value), [propertyName]: parseInt(value) });
    };
    const handleSubmit = (e) => {
        if (validator.current.allValid()) {
            // Update formData.numeroTelefono to match the phone state value
            setFormData({ ...formData, numeroTelefono: phone });
            formData.numeroTelefono = phone;
            // Now, submit the form with the updated formData
            web.post(ENDPOINT.REGISTRAZIONEMEDICOWEB, formData)
                .then(async (response) => {
                    if (response.status === 200 && response.data.statoEsito === 0) {
                        NotificationManager.success(message.MEDICO + message.SuccessUpdate, entitiesLabels.SUCCESS, 3000);
                        returnSplash()
                    } else {
                        NotificationManager.error(response.data.descrizioneEsito, entitiesLabels.ERROR, 3000);
                    }
                }).catch((error) => {
                    NotificationManager.error(message.ErrorServer, entitiesLabels.ERROR, 3000);
                }).finally(() => {
                    // Optional final logic
                });
        } else {
            validator.current.showMessages();
            setForceUpdate(!forceUpdate);
        }
    };
    const sendOTP = (e) => {
            if (validator.current.allValid()) {
                user.post(ENDPOINT.REQUESTOTP, phone.toString())
                    .then(async (response) => {
                        if (response.status === 200 && response.data.statoEsito === 0) {
                            setIsSuccessSendOtp(true);
                        } else {
                            NotificationManager.error(response.data.descrizioneEsito, entitiesLabels.ERROR, 3000);
                        }
                    }).catch((error) => {
                        NotificationManager.error(message.ErrorServer, entitiesLabels.ERROR, 3000);

                    })
                    .finally(() => {
                    });
            } else {
                validator.current.showMessages();
                validationPhone.current.showMessages();
                setForceUpdate(!forceUpdate);
            }
    };
    function returnSplash() {
        window.location.href = "/login";
    };
    if (formData.password === formData.confirmpassword) {
        var equalPass = true
    } else {
        var equalPass = false;
    }
    const validations = {

        nome: validator.current.message(
            'nome',
            formData.nome,
            'required'
        ),
        cognome: validator.current.message(
            'cognome',
            formData.cognome,
            'required'
        ),
        email: validator.current.message(
            'email',
            formData.email,
            'required|email'
        ),
        centroMedico: validator.current.message(
            'centroMedico',
            formData.idCentroMedico,
            'required'
        ),
        password: validator.current.message(
            'Password',
            formData.password,
            'required|min:8|regex:[0-9]|regex:[^a-zA-Z0-9]'
        ),
        confirmpassword: validator.current.message(
            'Confirm Password',
            formData.confirmpassword,
            'required|same:password'
        ),
        ck1: validator.current.message(
            'ck1',
            formDatack.ck1,
            'required'
        ),
        ck2: validator.current.message(
            'ck2',
            formDatack.ck2,
            'required'
        ),
        ck3: validator.current.message(
            'ck3',
            formDatack.ck3,
            'required'
        ),
        phone: validationPhone.current.message(
            'phone',
            phone,
            'required|min:8'
        ),
        equalPass: validator.current.message('equalPass', equalPass, 'accepted')
    }
    const validationsOTP = {
        otp: validatorOTP.current.message(
            'opt',
            formData.otp,
            'required'
        ),
    };
    const validationsPhone = {
        phone: validationPhone.current.message(
            'phone',
            phone,
            'required|min:8'
        ),
    };
    return (
        <div className="container" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h2 className="text-center">Registrazione Medico</h2>
            <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="formNome">
                            <Form.Label>Nome:</Form.Label>
                            <Form.Control
                                isInvalid={validations.nome != null}
                                type="text"
                                name="nome"
                                value={formData.nome}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="formCognome">
                            <Form.Label>Cognome:</Form.Label>
                            <Form.Control
                                isInvalid={validations.cognome != null}
                                type="text"
                                name="cognome"
                                value={formData.cognome}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email:</Form.Label>
                    <Form.Control
                        disabled={parseInt(window.location.pathname.split('/').pop()) ? true : false}
                        isInvalid={validations.email != null}
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Row className=''>
                    <Form.Group className="col-6 mb-2" controlId="formNumeroTelefono">
                        <Form.Label>Telefono :</Form.Label>
                        <PhoneInput
                            name="phone"
                            defaultCountry="it"
                            value={phone}
                            onChange={(phone) => setPhone(phone)}
                        />
                    </Form.Group>
                    <Form.Group className="col-6 mb-2" controlId="formNumeroCodiceMedico">
                        <Form.Label>Codice Medico :</Form.Label>
                        <div className="position-relative">
                            <Form.Control
                                type={'input'}
                                name="codiceMedico"
                                value={formData.codiceMedico}
                                onChange={handleInputChange}
                            />
                        </div>
                    </Form.Group>
                </Row>
                {validationsPhone.phone ? (
                    <div className=" input-layout-wrapper text-danger">
                        {' '}Inserire telefono{' '}
                    </div>
                ) : <div className=" input-layout-wrapper text-danger is-12">
                    {' '}{' '}
                </div>}
                <Row className=''>
                    <Form.Group className="col-6 mb-2" controlId="formPassword">
                        <Form.Control type={showPassword ? 'text' : 'password'} id='password' onChange={handleInputChange} name="password" isInvalid={validations.password != null} placeholder="Password" />
                    </Form.Group>
                    <Form.Group className="col-6 mb-2" controlId="formPassword">
                        <Form.Control type={showPassword ? 'text' : 'password'} id='confirmpassword' onChange={handleInputChange} name="confirmpassword" isInvalid={validations.confirmpassword != null || validations.equalPass != null} placeholder="Conferma Password" />
                    </Form.Group>
                    {validations.password ? (
                        <div className=" input-layout-wrapper text-danger">
                            {' '}La password deve avere una lunghezza di 8 caratteri e contenere un numero e un carattere speciale{' '}
                        </div>
                    ) : <div className=" input-layout-wrapper text-danger is-12">
                        {' '}{' '}
                    </div>}
                    {validations.equalPass ? (
                        <div className=" input-layout-wrapper text-danger">
                            {' '}
                            Le password devono coincidere{' '}
                        </div>
                    ) : <div className=" input-layout-wrapper text-danger is-12">
                        {' '}{' '}
                    </div>}
                </Row>
                <Row>
                    <span
                        className=""
                        style={{
                            display: 'flex',
                            'justify-content': 'flex-end',
                            left: '10px',
                            top: '8px',
                            cursor: 'pointer',
                        }}
                        onClick={togglePasswordVisibility}
                    >
                        {showPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                    </span>
                </Row>
                <Form.Group className="mb-3" controlId="formCentroMedico">
                    <Form.Label>Centro Medico:</Form.Label>
                    <Form.Select
                        isInvalid={validations.centroMedico != null}
                        className={validations.centroMedico != null ? 'validation-custom' : ''}
                        name="centroMedico"
                        value={formData.centroMedico}
                        onChange={handleInputChangeCentro}
                    >
                        {parseInt(window.location.pathname.split('/').pop()) ?
                            <option value={formData.nomeCentro} >{formData.nomeCentro}</option> :
                            <option value="">Seleziona Centro Medico</option>
                        }
                        {centrimedici.filter(x => x.nomeCentro !== formData.nomeCentro).map((item) =>
                            <option key={item.id} value={item.id}>{item.nomeCentro}</option>
                        )}
                    </Form.Select>
                    {validations.centroMedico != null ? <p className='custom-invalid-feedback'>Seleziona un centro medico</p> : <></>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="formPrivacy">
                    <Form.Check
                        name='ck1'
                        onClick={handleInputChangeck}
                        type="checkbox"
                        id="privacy1"
                        label={'1. Partecipazione al Patient Support Program (PSP)'}
                        checked={formDatack.ck1 ? true : false}
                    />
                    <p>Per consultare il documento completo cliccare <a href='/pdf/InformativaMedicoPuntoA.pdf' target='_blank'>qui.</a></p>
                    {validations.ck1 != null ? <p className='custom-invalid-feedback'>Accetta le condizioni descritte</p> : <></>}
                    <Form.Check
                        name='ck2'
                        onClick={handleInputChangeck}
                        type="checkbox"
                        id="privacy2"
                        label={'2. Comunicazioni operative'}
                        checked={formDatack.ck2 ? true : false}
                    />
                    <p>Per consultare il documento completo cliccare <a href='/pdf/InformativaMedicoPuntoB.pdf' target='_blank'>qui.</a></p>
                    {validations.ck2 != null ? <p className='custom-invalid-feedback'>Accetta le condizioni descritte</p> : <></>}
                    <Form.Check
                        name='ck3'
                        onClick={handleInputChangeck}
                        type="checkbox"
                        id="privacy3"
                        label={'3. Comunicazioni tecniche e assistenza'}
                        checked={formDatack.ck3 ? true : false}
                    />
                    <p>Per consultare il documento completo cliccare <a href='/pdf/InformativaMedicoPuntoC.pdf' target='_blank'>qui.</a></p>
                    {validations.ck3 != null ? <p className='custom-invalid-feedback'>Accetta le condizioni descritte</p> : <></>}
                </Form.Group>
                <Row>
                    <Col>
                        <Button className='btn btn-secondary btn-arrow' onClick={() => returnSplash()} >
                            Indietro
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={() => sendOTP()} variant="primary" className="w-100">Registra</Button>
                    </Col>
                </Row>
            </Form>
            <Modal
                show={isSuccessSendOtp}
                onHide={() => setIsSuccessSendOtp(false)}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="modal-80w"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{'Codice OTP inviato'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Form.Group className="col-12 mb-3" >
                            <Form.Label className="text-">Ti abbiamo inviato un <strong>codice di verifica</strong> al numero di cellulare indicato in fase di registrazione. Inseriscilo nel campo sottostante e premi Invia.</Form.Label>
                            {/* isInvalid={validationsOTP.otp != null} onChange={this.handleChangeOtp} */}
                            <Form.Control name="otp" alt="patiendDto" id="otp" placeholder="Inserisci il codice OTP" onChange={handleInputChange} isInvalid={validationsOTP.otp != null} onKeyDown={event => { if (event.key === 'Enter') { handleSubmit() } }} />
                        </Form.Group>
                    </Row>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="secondary" onClick={() => setIsSuccessSendOtp(false)}>
                        Chiudi
                    </Button>
                    <button class="btn btn-secondary mx-2" id="reinvia" onClick={() => sendOTP()} >Invia di nuovo</button>
                    <Button variant="primary" onClick={() => handleSubmit()}>
                        Invia
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={ismodalpdf}
                onHide={() => handleInputChangeck()}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
            >
                <Modal.Body >
                    <iframe
                        src={pdfElement}
                        width="100%"
                        height="600px"
                        title="PDF Viewer"
                    ></iframe>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="secondary" onClick={() => handleInputChangeck()}>
                        Chiudi
                    </Button>
                    <Button variant="primary" onClick={() => confirmInputChangeck(ck)}>
                        Accetta
                    </Button>
                </Modal.Footer>
            </Modal>
            < NotificationContainer />
        </div>
    );
}

export default RegistrazioneMedicoWeb;